<template>
  <div
    class="contenedor-general"
    ref="sheet"
    :class="{ abriendo: isOpening, cerrando: isClosing }"
  >
    <div id="mobile" @click="handleCerrar">
      <div class="linea" @click="handleCerrar">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="4"
          viewBox="0 0 24 4"
          fill="none"
        >
          <path
            d="M2 2H22"
            stroke="#CDCDCD"
            stroke-width="3"
            stroke-linecap="round"
          />
        </svg>
      </div>
    </div>
    <div>
      <h2 class="h1-default">
        <img
          src="./../../assets/images/LuqueIconoLapiz.svg"
          alt=""
          style="margin-right: 0.5vw"
          class="lapizMobile"
        />Nuevo
        {{ titulo }}
      </h2>
      <div class="datos">
        <div style="position: relative">
          <h2 class="h2-hero color">Categoría:</h2>
          <div class="select" @click="toggleCategory">
            <p class="p-base text" v-if="category">{{ category.title }}</p>
            <p v-else class="p-base text">Seleccioná la Categoría</p>
          </div>
          <div class="options" v-if="selectCategory">
            <div
              name=""
              id=""
              v-for="(item, index) in categories"
              :key="index"
              class="p-base option text"
            >
              <div v-if="item.ruta" @click="setCategory(item)">
                {{ item.title }}
              </div>
              <div
                v-else
                style="
                  display: flex;
                  flex-direction: row;
                  gap: 4.71vw;
                  align-items: center;
                "
              >
                {{ item.title }}

                <p class="p-hero botonN">No autorizado</p>
              </div>
            </div>
          </div>
        </div>
        <div style="position: relative" v-if="subCategories?.length > 0">
          <h2 class="h2-hero">Opción:</h2>

          <div
            class="select text"
            :class="{ disabled: !category }"
            @click="category ? toggleSubCategory() : null"
          >
            <p v-if="subCategory" class="p-base text">
              {{ subCategory.title }}
            </p>
            <p v-else class="p-base text">Seleccioná la Opción de Categoría</p>
          </div>
          <div class="options" v-if="selectSubCategory && category">
            <div
              v-for="(item, index) in subCategories"
              :key="index"
              @click="setSubCategory(item)"
              class="p-base option"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
        <div style="position: relative">
          <h2 class="h2-hero colorA" :class="{ color: category }">Trámites:</h2>
          <div
            class="select colorA"
            :class="{
              color: category,
              disabled:
                !category || (subCategories?.length > 0 && !subCategory),
            }"
            @click="habilitadoProcedures ? toggleProcedure() : null"
          >
            <p v-if="procedure" class="p-base text">{{ procedure.title }}</p>
            <p v-else class="p-base text">
              {{
                !category
                  ? "Seleccioná primero una categoría"
                  : subCategories?.length > 0 && !subCategory
                    ? "Seleccioná una opción primero"
                    : "Seleccioná el Trámite"
              }}
            </p>
          </div>
          <div class="options" v-if="selectProcedure && habilitadoProcedures">
            <div
              v-for="(item, index) in procedures"
              :key="index"
              @click="setProcedure(item)"
              class="p-base option"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-modal">
      <router-link
        v-if="puedeReservar"
        :to="`/requisitos/${procedure.title}/${procedure.id}`"
      >
        <BtnBComponent
          :texto="textoBoton"
          :disabled="!puedeReservar"
          style="background: var(--backgroundGrisGradient)"
        />
      </router-link>

      <BtnBComponent
        v-else
        :texto="textoBoton"
        :disabled="true"
        style="
          background: var(--backgroundGrisGradient);
          opacity: 0.5;
          cursor: not-allowed;
        "
      />
    </div>
  </div>
</template>
<script>
import BtnBComponent from "../Buttons/BtnBComponent.vue";
import {
  getAllCategories,
  getCategoriesInPerson,
  getSubCateries,
  getProceduresSubCategory,
} from "@/services/offiVecino/Categorias/getCategoriesServis";
export default {
  emits: ["cerrar"],

  name: "ModalAgregarComponent.vue",
  data() {
    return {
      categories: [], //para seleccionar
      subCategories: null, //para seleccionar
      subCategoriesTurno: null,
      procedures: null, //para seleccionar
      selectCategory: false, //para extender y seleccionar
      selectSubCategory: false, //para extender y seleccionar
      selectProcedure: false, //para extender y seleccionar
      category: "", //seleccionado
      subCategory: "", //seleccionado
      procedure: "", //seleccionado
      procedureTurnos: null,
      idCategories: null,
      isOpening: false,
      isClosing: false,
      dragging: false,
      startY: 0,
      translateY: 0,
    };
  },
  mounted() {
    this.isOpening = true;

    if (window.innerWidth <= 770) {
      const modal = this.$refs.sheet;
      setTimeout(() => {
        modal.style.transform = "translateY(0)";
      }, 400);

      modal.addEventListener("touchstart", this.onTouchStart, {
        passive: false,
      });
      modal.addEventListener("touchmove", this.onTouchMove, { passive: false });
      modal.addEventListener("touchend", this.onTouchEnd);
    }
  },

  beforeUnmount() {
    if (window.innerWidth <= 770) {
      const modal = this.$refs.sheet;
      modal.removeEventListener("touchstart", this.onTouchStart);
      modal.removeEventListener("touchmove", this.onTouchMove);
      modal.removeEventListener("touchend", this.onTouchEnd);
    }
  },

  created() {
    if (this.titulo === "Turno") {
      this.getCategoriesTurnos();
    } else {
      this.getCategories();
    }
    // this.idCategories = this.$store.state.categoriesRelations || null;
  },
  computed: {
    textoBoton() {
      return this.titulo === "Turno" ? "Reservar" : "Iniciar";
    },
    habilitadoProcedures() {
      if (!this.category) return false;
      if (this.subCategories?.length > 0 && !this.subCategory) return false;
      return true;
    },
    puedeReservar() {
      if (!this.category) return false;

      if (this.subCategories?.length > 0 && !this.subCategory) return false;

      if (!this.procedure) return false;

      return true;
    },
  },

  methods: {
    toggleCategory() {
      this.selectCategory = !this.selectCategory;
      if (this.selectCategory) {
        this.selectSubCategory = false;
        this.selectProcedure = false;
      }
    },
    toggleSubCategory() {
      this.selectSubCategory = !this.selectSubCategory;
      if (this.selectSubCategory) {
        this.selectCategory = false;
        this.selectProcedure = false;
      }
    },

    toggleProcedure() {
      this.selectProcedure = !this.selectProcedure;
      if (this.selectProcedure) {
        this.selectCategory = false;
        this.selectSubCategory = false;
      }
    },
    handleCerrar() {
      this.isClosing = true; // Solo para transición normal
      this.isOpening = false;
      setTimeout(() => {
        this.$emit("cerrar");
        this.isClosing = false;
      }, 350);
    },

    async getCategories() {
      try {
        let { formales, impuestos, transito, general } =
          await getAllCategories();
        this.categories = this.categories.concat(
          formales,
          impuestos,
          transito,
          general,
        );

        // console.log(this.categories, "soy las cate");
      } catch (error) {
        console.error("Error al obtener las categorias:", error);
      }
    },
    async getCategoriesTurnos() {
      try {
        let { categoriesApi, proceduresApi, subCategoriesApi } =
          await getCategoriesInPerson();

        const uniqueCategories = categoriesApi.filter(
          (cat, index, self) =>
            index === self.findIndex((c) => c.id === cat.id),
        );
        const categoriesWithProcedures = uniqueCategories.map((cat) => {
          const relatedProcedures = proceduresApi.filter(
            (proc) => proc.category?.id === cat.id,
          );
          return { ...cat, procedures: relatedProcedures };
        });

        this.categories = categoriesWithProcedures;
        this.subCategoriesTurno = subCategoriesApi;
        this.procedureTurnos = proceduresApi;
      } catch (error) {
        console.error("Error al obtener categorías de turnos:", error);
      }
    },

    async getSubCateg() {
      try {
        // if (!this.subCategories) {
        let { subCategories, procedures } = await getSubCateries(
          this.category.id,
        );
        this.subCategories = subCategories;
        this.procedures = procedures;
        // }
      } catch (error) {
        console.error("Error al obtener los tramites:", error);
      }
    },
    async GetProcedures() {
      try {
        let response = await getProceduresSubCategory(this.subCategory.id);
        this.procedures = response;
      } catch (error) {
        console.error("Error al obtener los tramites:", error);
      }
    },

    async setCategory(item) {
      this.category = item;
      this.setcategorySore(item);
      this.selectCategory = false;

      this.subCategories = [];
      this.procedures = [];

      if (this.titulo === "Turno") {
        this.subCategories = this.subCategoriesTurno.filter(
          (sub) => sub.category?.id === item.id,
        );

        this.procedures = this.procedureTurnos.filter(
          (proc) => proc.category?.id === item.id,
        );

        return;
      }

      const { subCategories } = await getSubCateries(item.id);
      this.subCategories = subCategories;

      if (!subCategories.length) {
        this.procedures = await getProceduresSubCategory(item.id);
      }
    },
    async setSubCategory(item) {
      this.subCategory = item;
      this.selectSubCategory = false;

      if (this.titulo === "Turno") {
        this.procedures = this.procedureTurnos.filter(
          (proc) => proc.subCategory?.id === item.id,
        );
        return;
      }

      this.procedures = await getProceduresSubCategory(item.id);
    },
    setProcedure(item) {
      this.procedure = item;
      // console.log(this.procedure, "soy el procedure");
      this.setTramiteStore(item);
      this.selectProcedure = false;
    },
    setTramiteStore(procedure) {
      this.$store.dispatch("setTramiteAction", procedure);
    },
    setcategorySore(category) {
      this.$store.dispatch("setCategoryAction", category);
    },
    onTouchStart(e) {
      const modal = this.$refs.sheet;

      // Solo permitir arrastrar si está completamente arriba
      if (modal.scrollTop > 0) return;

      this.dragging = true;
      this.startY = e.touches[0].clientY;
      this.translateY = 0;
      modal.style.transition = "none";
    },

    onTouchMove(e) {
      if (!this.dragging) return;

      e.preventDefault();

      const diff = e.touches[0].clientY - this.startY;
      if (diff > 0) {
        this.translateY = diff;
        this.$refs.sheet.style.transform = `translateY(${diff}px)`;
      }
    },
    onTouchEnd() {
      this.dragging = false;
      const modal = this.$refs.sheet;

      if (this.translateY > 140) {
        modal.style.transition = "transform 0.25s ease-out";
        modal.style.transform = `translateY(100%)`;

        setTimeout(() => {
          this.$emit("cerrar");
        }, 250);
      } else {
        modal.style.transition = "transform 0.25s ease-out";
        modal.style.transform = `translateY(0)`;
      }

      this.translateY = 0;
    },
  },
  props: {
    titulo: String,
  },
  components: {
    BtnBComponent,
  },
};
</script>
<style scoped>
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0px;
  color: var(--text-primary);
}
.contenedor-general {
  height: var(--heightComprobantes);
  width: var(--widthComprobantes);
  border-radius: 30px;
  background: var(--bg-popup);
  padding: var(--gap30) var(--gapH50);
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.datos {
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: var(--gap15);
  margin-top: var(--gap20);
}
.select {
  width: 100%;
  height: var(--gap30);
  border-radius: 8px;
  background: var(--textarea);
  padding-left: var(--gapH10);
  margin-top: var(--gap10);
  align-content: center;
  color: var(--text-primary);
  outline: none;
  position: relative;
}
.text {
  color: var(--text-primary);
}
.options {
  width: 100%;
  border-radius: 0.5rem;
  background: var(--textarea);
  top: 10.851vh;
  left: 0px;
  display: flex;
  flex-direction: column;
  gap: var(--gap10);
  padding: var(--gap10) var(--gapH20);
  max-height: 35vh;
  overflow-y: auto;
  position: absolute;
  color: var(--text-primary);
  z-index: 10;
}

.select.disabled {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}

.option {
  cursor: pointer;

  transition:
    background 0.2s ease,
    color 0.2s ease;
}
.option:hover {
  background: rgba(0, 195, 168, 0.12);
  color: var(--text-primary);
  font-weight: 600;
  border-radius: 4px;
}
.options::-webkit-scrollbar {
  display: none;
}
.footer-modal {
  text-align: center;
}
.botonN {
  width: 7.61vw;
  background: var(--blancoCard);
  backdrop-filter: var(--blur);
  height: 5vh;
  border-radius: 8px;
  align-content: center;
  text-align: center;
}
.colorA {
  /* color: var(--gris-claro) !important; */
  opacity: 0.5;
}
.color {
  /* color: var(--text-primary) !important; */
  opacity: 1;
}
#mobile {
  display: none;
}
.linea {
  display: none;
}
@media (max-width: 770px) {
  .contenedor-general {
    height: 83.472vh;
    width: 100%;
    padding: var(--gap20) var(--gapHM20);
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    border-radius: unset;
    flex-direction: column;
    justify-content: unset;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.25);
    animation: slideUp-5b0522d2 0.35s ease-out;
    z-index: 999;

    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }

  #mobile {
    margin-top: -2.504vh;
    display: block;
  }

  .linea {
    display: block;
  }

  .contenedor-general.abriendo {
    animation: slideUp 0.4s ease-out;
  }

  .contenedor-general.cerrando {
    animation: slideDown 0.3s ease-in forwards;
  }

  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }

  @keyframes slideDown {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(100%);
    }
  }

  .lapizMobile {
    height: var(--gap15);
    width: var(--gapHM15);
  }
  .datos {
    gap: 8px;
  }
  .select {
    width: 100%;
    height: var(--gap25);
    border-radius: 8px;
    padding-left: var(--gapHM20);
    margin-top: var(--gap5);
    align-content: center;
    color: var(--text-primary);
    outline: none;
    position: relative;
  }
  .options {
    width: 100%;
    border-radius: 8px;
    top: var(--margin60);
    left: 0px;
    display: flex;
    flex-direction: column;
    gap: var(--gap10);
    padding: var(--gap10) var(--gapHM20);
    max-height: 30vh;
    overflow-y: auto;
    position: absolute;
    color: var(--text-primary);
    z-index: 10;
  }

  .footer-modal {
    position: fixed;
    bottom: 3.339vh;
    left: 0;
    width: 100%;
    text-align: center;
    z-index: 1001;
  }

  .contenedor-general {
    transition: transform 0.35s ease-out;
    will-change: transform;
    touch-action: none;
  }
}
</style>
